/*
 * AdminGroups Messages
 *
 * This contains all the text for the AdminGroups component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  groups: {
    id: 'app.components.AdminGroups.groups',
    defaultMessage: 'Groups',
  },
  school: {
    id: 'app.components.AdminGroups.school',
    defaultMessage: 'School',
  },
  schoolIntro: {
    id: 'app.components.AdminGroups.schoolIntro',
    defaultMessage: 'The School Group contains all students, parents and employees from the school. So you know your will reach everybody and have a fixed spot for general school news.',
  },
  foundation: {
    id: 'app.components.AdminGroups.foundation',
    defaultMessage: 'Foundation',
  },
  foundationIntro: {
    id: 'app.components.AdminGroups.foundationIntro',
    defaultMessage: 'These groups are updated automatically.',
  },
  viewArchive: {
    id: 'app.components.AdminGroups.viewArchive',
    defaultMessage: 'View Archive',
  },
  classes: {
    id: 'app.components.SideMenu.classes',
    defaultMessage: 'Classes',
  },
  class: {
    id: 'app.components.AdminGroups.class',
    defaultMessage: 'Class',
  },
  classIntro: {
    id: 'app.components.AdminGroups.classIntro',
    defaultMessage: 'Classes are the core of your communication at school. You can connect classes the the administrative system so students will automatically be updated. You can also plan parent meetings and view absence reports of the students.',
  },
  general: {
    id: 'app.components.AdminGroups.general',
    defaultMessage: 'General Groups',
  },
  general1: {
    id: 'app.components.AdminGroups.general1',
    defaultMessage: 'General Group',
  },
  generalIntro: {
    id: 'app.components.AdminGroups.generalIntro',
    defaultMessage: 'Using general groups you can make other relations within the school to make a group, for example the Parent Council. In addition you can compose groups from classes, e.g. the lower and the advanced grades.',
  },
  generalFoundationIntro: {
    id: 'app.components.AdminGroups.generalFoundationIntro',
    defaultMessage: 'Make general groups e.g., for directors\' consultation or extracurricular classes.',
  },
  noGroups: {
    id: 'app.components.AdminGroups.noGroups',
    defaultMessage: 'No Groups',
  },
  addClass: {
    id: 'app.components.AdminGroups.addClass',
    defaultMessage: 'Add Class',
  },
  addGroup: {
    id: 'app.components.AdminGroups.addGroup',
    defaultMessage: 'Add Group',
  },
  name: {
    id: 'app.components.AdminGroups.name',
    defaultMessage: 'Name',
  },
  members: {
    id: 'app.common.members',
    defaultMessage: 'Members',
  },
  community: {
    id: 'app.components.AdminGroups.community',
    defaultMessage: 'Community',
  },
  conversations: {
    id: 'app.components.AdminGroups.conversations',
    defaultMessage: 'Conversations',
  },
  personalMessages: {
    id: 'app.components.AdminGroups.personalMessages',
    defaultMessage: 'Personal Messages',
  },
  archive: {
    id: 'app.components.AdminGroups.archive',
    defaultMessage: 'Archive',
  },
  archiveIntro: {
    id: 'app.components.AdminGroups.archiveIntro',
    defaultMessage: 'Archive groups can be viewed under \'My Groups\'. No new content can be added to the group.',
  },
  confirmArchiveClassModalTitle: {
    id: 'app.components.AdminUsers.confirmArchiveClassModalTitle',
    defaultMessage: 'Archive class inboxes?',
  },
  confirmArchiveClassModalIntro: {
    id: 'app.components.AdminUsers.confirmArchiveClassModalIntro',
    defaultMessage: 'When you archive the class inboxes, the following happens:',
  },
  archivedClassInboxRules: {
    id: 'app.components.AdminUsers.archivedClassInboxRules',
    defaultMessage: '<ul><li>The inboxes are removed from all conversations.</li><li>No more new conversations can be started from the inboxes</li><li>Owners of each class can review all conversations to date at their archived inboxes.</li></ul>',
  },
  messages: {
    id: 'app.components.AdminGroups.messages',
    defaultMessage: 'Messages',
  },
  archivedOn: {
    id: 'app.components.AdminGroups.archivedOn',
    defaultMessage: 'Archived on',
  },
  doArchive: {
    id: 'app.components.AdminUsers.doArchive',
    defaultMessage: 'Archive',
  },
  delete: {
    id: 'app.common.delete',
    defaultMessage: 'Delete',
  },
  deleteOn: {
    id: 'app.components.AdminGroups.deleteOn',
    defaultMessage: 'Delete Date',
  },
  changeDeleteDate: {
    id: 'app.components.AdminGroups.changeDeleteDate',
    defaultMessage: 'Change Delete Date',
  },
  deleteNow: {
    id: 'app.components.AdminGroups.deleteNow',
    defaultMessage: 'Delete Group Now',
  },
  newDate: {
    id: 'app.components.AdminGroups.newDate',
    defaultMessage: 'New Date',
  },
  confirmDeleteNow: {
    id: 'app.components.AdminGroups.confirmDeleteNow',
    defaultMessage: 'Delete group "{group}" immediately?',
  },
  groupDeleted: {
    id: 'app.components.AdminGroups.groupDeleted',
    defaultMessage: 'The group has been deleted',
  },
  searchedFor: {
    id: 'app.components.Search.searchedFor',
    defaultMessage: 'Search Results for "{search}"',
  },
  classInbox: {
    id: 'app.components.AdminGroups.classInbox',
    defaultMessage: 'Class Inbox',
  },
  classInboxIntro: {
    id: 'app.components.AdminGroups.classInboxIntro',
    defaultMessage: 'Class owners have a shared inbox that they manage together, members of the class can choose this inbox when they start a conversation.',
  },
  unarchive: {
    id: 'app.components.AdminGroups.unarchive',
    defaultMessage: 'Restore Group',
  },
});
